import { ChangeEvent, useEffect, useState } from 'react';
import { ModalWithButtons } from '../../ModalWithButtons/ModalWithButtons.component';
import { LabelsListItem } from './Label.types';
import { FormHelperTextProps, Grid, TextField } from '@material-ui/core';
import { ValidationRow } from '../../ValidationRow/ValidationRow.components';
import { LeavePrompt } from '../../Prompt/LeavePrompt/LeavePrompt.component';

interface EditLabelProps {
  label?: LabelsListItem;
  onChange: (name: string, value: string) => void;
  onCancel: () => void;
  onClose: () => void;
}

const LABEL_MIN_LENGTH = 3;
const LABEL_MAX_LENGTH = 256;

export const EditLabel: React.FC<EditLabelProps> = ({ label, onChange, onCancel }) => {
  const [labelValue, setLabelValue] = useState<string>('');
  const [isDataChanged, setIsDataChanged] = useState<boolean>(false);
  const [isWrongLabelName, setIsWrongLabelName] = useState<boolean>(false);
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState<boolean>(false);
  const [hasNameFocus, setHasNameFocus] = useState<boolean>(false);

  const isLabelNameToLong = labelValue.length > LABEL_MAX_LENGTH;
  const isLabelNameToShort = labelValue.length < LABEL_MIN_LENGTH;

  useEffect(() => {
    if (!label) return;
    setLabelValue(label.value);
  }, [label]);

  useEffect(() => {
    setIsDataChanged(label?.value !== labelValue);
    setIsWrongLabelName(!labelValue.length || isLabelNameToShort || isLabelNameToLong);
  }, [labelValue]);

  const handleLabelValueChange = (value: string) => {
    setLabelValue(value);
  };

  const handleCancel = () => {
    isDataChanged ? setIsLeavePromptOpen(true) : onCancel();
  };

  const handleOnChange = () => {
    if (label?.value) {
      onChange(label.name, labelValue);
    }
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={handleCancel}
        open={true}
        size="sm"
        title={'Edytuj etykietę'}
        autoHeight
        onCancel={handleCancel}
        confirmButtonLabel="Zapisz"
        onConfirm={handleOnChange}
        confirmButtonDisabled={!isDataChanged || isWrongLabelName}
        buttonsContainerStyle={{ marginTop: '20px' }}
        handleClose={() => setIsLeavePromptOpen(true)}
        isHideBackdrop={true}
      >
        <Grid container>
          <Grid item xs={12}>
            <TextField
              value={labelValue}
              onChange={(e: ChangeEvent<HTMLInputElement>) => handleLabelValueChange(e.target.value)}
              label="Nazwa etykiety"
              variant="outlined"
              fullWidth
              inputProps={{
                style: {
                  color: isWrongLabelName ? 'red' : 'black',
                },
              }}
              onFocus={() => setHasNameFocus(true)}
              onBlur={() => setHasNameFocus(false)}
              error={isWrongLabelName}
              FormHelperTextProps={
                {
                  component: 'div',
                } as Partial<FormHelperTextProps<'p'>>
              }
              helperText={
                <ValidationRow
                  helperText={isWrongLabelName ? 'Dozwolona liczba znaków od 3 do 256' : ''}
                  limitsVisible={hasNameFocus}
                  valueLength={labelValue.length}
                  limit={LABEL_MAX_LENGTH}
                  withError={isWrongLabelName}
                />
              }
            />
          </Grid>
        </Grid>
      </ModalWithButtons>
      <LeavePrompt isOpen={isLeavePromptOpen} onConfirm={onCancel} onCancel={() => setIsLeavePromptOpen(false)} />
    </>
  );
};
